import React, { memo } from 'react';
import type { ArticleEntryType } from 'tsconfig/types';
import { Article } from '../../Article/Article';

export type CmsArticleProps = {
  contentItem: ArticleEntryType;
  dlClickEventHandler?: (data: string) => void;
};

export const CmsArticle: React.FC<CmsArticleProps> = memo(({ contentItem: { fields, sys }, dlClickEventHandler }) => {
  const { entryTitle, link, icamp, media, primaryHeader, secondaryHeader, content, publishedDate } = fields || {};

  return media && content ? (
    <Article
      entryTitle={entryTitle}
      link={link}
      icamp={icamp}
      media={media}
      content={content}
      primaryHeader={primaryHeader}
      secondaryHeader={secondaryHeader}
      publishedDate={publishedDate}
      id={sys?.id}
      dlClickEventHandler={dlClickEventHandler}
    />
  ) : null;
});
